import { memo } from 'react'

import DressUpPage, { TEST_ID } from './DressUp'

const DressUp = memo(DressUpPage)

export { TEST_ID }

export default DressUp
